import {Row, Typography} from "antd";
import React from "react";

const BORDER_COLOR = '#e0e0e0';
const FONT_COLOR = 'var(--primary)';


const contentConfig = {
  className: 'pt-2 px-6 my-3',
  style: {
      borderRadius: 4,
      background: 'rgba(255, 255, 255, 1)',
      padding: '1.25% 2.5%',
      maxWidth: 800,
      margin: 'auto'
  }
}


const ContentTitle = ({title, extra})=>{
  return (
    <Row align={'middle'} justify={'start'} style={{padding: '5px 0px 20px 2px', borderRadius: '0'}}>
      <Typography.Text style={{
          textTransform: 'capitalize',
          fontWeight: '500',
          fontSize: '16px',
          color: FONT_COLOR
      }}
      >
          {title}
      </Typography.Text>
      {extra}
    </Row>
  )
}



export {
    contentConfig,
    ContentTitle,
    BORDER_COLOR,
    FONT_COLOR
}
